"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.9 7.2l-.2.6h1.4c.33 0 .53.196.44.436l-2.68 7.528c-.09.24-.43.436-.76.436H7.7l-.2.6h5.8l.2-.6h-1.6c-.33 0-.53-.196-.44-.436l2.68-7.528c.09-.24.43-.436.76-.436h1.4l.2-.6h-5.6z" }), "Italic");
//# sourceMappingURL=Italic.js.map